<template>
<div class="row"
     v-if="person">
	<div class="col-12">
		<h1>
			<span v-if="person.salutation" class="d-none">{{ person.salutation}} </span>{{ person.full_name }}<span v-if="person.code"> ({{ person.code }})</span>
			<router-link :to="{ name: 'personEdit', params: { personId: person.id } }" target="_blank">
				<small class="edit-icon"><fa-icon icon="edit"></fa-icon></small>
			</router-link>
		</h1>

		<p>
			<small>{{ $t('person.registeredAt') }} {{ person.created_at | smallDate }}</small>
		</p>

		<address>
			<p v-if="person.address || person.zipcode || person.city || person.country">
				<span v-if="person.address">{{ person.address }}<br /></span>
				<span v-if="person.zipcode">{{ person.zipcode }} </span><span v-if="person.city">{{ person.city }}</span><br v-if="person.zipcode || person.city" />
				<span v-if="person.country">{{ person.country }}</span>
			</p>

			<p>
				<span v-if="person.email"><a :href="`mailto:${person.email}`">{{ person.email }}<br /></a></span>
				<span v-if="person.telephone">{{ `${this.$t('person.telephone')}: `}}<a :href="`tel:${person.telephone}`">{{ person.telephone }}</a></span><br />
				<span v-if="person.mobile">{{ `${this.$t('person.mobile')}: `}}<a :href="`tel:${person.mobile}`">{{ person.mobile }}</a></span>
			</p>
		</address>

		<p v-if="person.fixed_bid_number"
		   class="font-italic">
			{{ $t('person.fixedBidNumber') }} {{ person.fixed_bid_number }}
		</p>
	</div>
</div>
</template>
<script>
import { isNil } from 'lodash';
import { smallDate } from '@/filters/date-filters';

export default {
	data: () => ({

	}),
	filters: {
		smallDate
	},
	props: {
		person: {
			type: Object
		},
	},
	methods: {

	}
}
</script>
<style lang="scss" scoped>
.edit-icon {
    font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// PersonInfo.vue?7e3e61bf